module.exports = __webpack_public_path__ + "static/playground@large-a254f05bf3f833658302951d903dc998.jpg";